import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-11.957-1.793a2.182 2.182 0 0 0-3.086 3.086l2.25 2.25a1 1 0 0 1-1.414 1.414l-2.25-2.25a4.182 4.182 0 1 1 5.914-5.914l2.25 2.25a1 1 0 0 1-1.414 1.414zm4.164-3.164a1 1 0 1 0-1.414 1.414l2.25 2.25a2.182 2.182 0 0 1-3.086 3.086l-2.25-2.25a1 1 0 0 0-1.414 1.414l2.25 2.25a4.182 4.182 0 1 0 5.914-5.914z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSoftwareDevelopmentAuthy = { render };
export {
  brandSoftwareDevelopmentAuthy as default,
  render
};
//# sourceMappingURL=brand-software-development-authy.svg.js.map
